import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { environment } from '../../../../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';
import { ConfigService } from '../../../../../../services/config/config.service';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';


@Component({
    selector: 'fuse-student-excel-configuration',
    templateUrl: './student-excel-configuration.component.html',
    styleUrls: ['./student-excel-configuration.component.scss'],
    animations: fuseAnimations
})
export class StudentExcelConfigurationComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;

    public attrs = [];
    public shifts = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<StudentExcelConfigurationComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        public authenticationService: AuthenticationService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        private jobTitleService: JobTitleService,
        private configService: ConfigService
    ) {
        console.log('FuseAddStudentComponent > data', data);
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.shiftService.getAll(),
            this.configService.getStudentAttrs()
        ).subscribe(([shifts, studentAttrs]) => {
            let authData = this.authenticationService.getAuthData()
            this.shifts = shifts.filter(e => {
                if (authData.Shifts.find(s => s.Id === e.Id)) {
                    console.log("******** = " + e.Id + " d = " + e.Description);
                    return {Id: e.Id, Description: e.Description, Checked: false};
                } 
            });

            studentAttrs.forEach(e => {
                e.Checked = false;
            });

            this.attrs = studentAttrs;

            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }


    save() {
        const attrs = this.attrs.filter(e => e.Checked).map(e => e.Id);
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        console.log('d', environment.backendUri + 'report/excel/student/' + attrs + '/' + shifts + '/' + this.data.schoolYearId);
        window.open(environment.backendUri + 'report/excel/student/' + attrs + '/' + shifts + '/' + this.data.schoolYearId, '_new');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/student-excel-configuration/student-excel-configuration.component.ts